<section>
  <kendo-grid [data]="promoCodeGridView"
              (filterChange)="promoCodeGridFilterChange($event)"
              [height]="470"
              [sortable]="true"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="false"
              [sort]="promoCodeGridstate.sort"
              (sortChange)="promoCodeGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }"
              [pageSize]="promoCodeGridstate.take"
              [skip]="promoCodeGridstate.skip"
              [columnMenu]="false"
              (pageChange)="promoCodeGridPageChange($event)"
              [filter]="promoCodeGridstate.filter"
              [loading]="promoCodeLoading">

    <!-- Promo Code -->
    <kendo-grid-column field="code" title="Promo Code" [width]="100" [filterable]="true">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <!-- Description -->
    <kendo-grid-column field="description" title="Description" [width]="120" [filterable]="true">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <!-- Product -->
    <kendo-grid-column field="productName" title="Product" [width]="150">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="ellipsis-cell"
              [title]="dataItem.productName">
          {{ dataItem.productName }}
        </span>
      </ng-template>
    </kendo-grid-column>

    <!-- Finish -->
    <kendo-grid-column field="finish" title="Finish" [width]="100">

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.finish === 'ALL' ? 'All' : dataItem.finish }}
      </ng-template>

    </kendo-grid-column>

    <!-- Free Freight -->
    <kendo-grid-column field="freeFreight" title="Free Freight" [width]="100" [filterable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.freeFreight }}
      </ng-template>
    </kendo-grid-column>

    <!-- One Time -->
    <kendo-grid-column field="oneTime" title="One Time" [width]="100" [filterable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.oneTime }}
      </ng-template>
    </kendo-grid-column>

    <!-- Currency -->
    <kendo-grid-column field="currency" title="Currency" [width]="100" [filterable]="true">
    </kendo-grid-column>


    <!-- Discount -->
    <kendo-grid-column field="discount" title="Discount" [width]="100" [filterable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.discountDisplay }}
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <!-- Min Value -->
    <kendo-grid-column field="minPrice" title="Min Value" [width]="100" [filterable]="true">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-numeric-filter-cell [column]="column"
                                        [filter]="filter">
          <kendo-filter-contains-operator>
          </kendo-filter-contains-operator>
        </kendo-grid-numeric-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <!-- Max Value -->
    <kendo-grid-column field="maxPrice" title="Max Value" [width]="100" [filterable]="true">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-numeric-filter-cell [column]="column"
                                        [filter]="filter">
          <kendo-filter-contains-operator>
          </kendo-filter-contains-operator>
        </kendo-grid-numeric-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <!-- Region -->
    <kendo-grid-column field="region"
                       title="Region"
                       [width]="100"
                       [filterable]="true">

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.region || '-' }}
      </ng-template>

    </kendo-grid-column>
    <!-- Territory -->
    <kendo-grid-column field="territory"
                       title="Territory"
                       [width]="120"
                       [filterable]="true">

      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="ellipsis-cell"
              [title]="dataItem.territory || '-'">
          {{ dataItem.territory || '-' }}
        </span>
      </ng-template>

    </kendo-grid-column>

    <!-- CustomerNo-->
    <kendo-grid-column field="customerNo"
                       title="Customer No"
                       [width]="100"
                       [filterable]="true">

      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.customerNo || '-' }}
      </ng-template>

    </kendo-grid-column>


    <!-- Date Range -->
    <kendo-grid-column field="dateRangeSort"
                       title="Date Range"
                       [width]="220">

      <ng-template kendoGridFilterCellTemplate>

        <div style="display:flex;align-items:center;gap:2px;">

          <kendo-datepicker style="width:75px;"
                            [(ngModel)]="dateRangeFrom"
                            (valueChange)="onDateRangeFilterChange()"
                            format="MM/dd/yyyy"
                            placeholder="From">
          </kendo-datepicker>

          <kendo-datepicker style="width:75px;"
                            [(ngModel)]="dateRangeTo"
                            (valueChange)="onDateRangeFilterChange()"
                            format="MM/dd/yyyy"
                            placeholder="To">
          </kendo-datepicker>

          <button class="k-button k-button-icon"
                  title="Clear Filter"
                  (click)="clearDateRangeFilter()">
            <span class="k-icon k-i-filter-clear"></span>
          </button>

        </div>

      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <span style="white-space: nowrap;">
          {{ dataItem.startDate | date:'MM/dd/yyyy' }}
          -
          {{ dataItem.endDate | date:'MM/dd/yyyy' }}
        </span>
      </ng-template>

    </kendo-grid-column>

    <div>
      Currency Count: {{currencyList.length}}
    </div>

    <div class="form-group">
      <label class="lblCls">Currency<span class="requiredField">*</span></label>

      <kendo-multiselect [data]="currencyList"
                         textField="text"
                         valueField="value"
                         [valuePrimitive]="true"
                         formControlName="currency"
                         [autoClose]="false"
                         (valueChange)="onCurrencyChange($event)">
      </kendo-multiselect>
    </div>
    <!-- IsActive Column -->
    <kendo-grid-column title="Show Inactive?" field="isActive" [width]="125">

      <!-- Filter Dropdown -->
      <ng-template kendoGridFilterCellTemplate>
        <kendo-dropdownlist [data]="isActiveFilterDropdown"
                            textField="text"
                            valueField="value"
                            [valuePrimitive]="true"
                            [value]="isActiveHeaderValue"
                            (valueChange)="onIsActiveHeaderChange($event)"
                            style="width: 100%;">
        </kendo-dropdownlist>
      </ng-template>

      <!--  Switch Display -->
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch [(ngModel)]="dataItem.isActive"
                      [onLabel]="'Yes'"
                      [offLabel]="'No'"
                      [disabled]="true">
        </kendo-switch>
      </ng-template>

    </kendo-grid-column>
    <!-- Action Column -->
    <kendo-grid-command-column title="Action" [width]="150">

      <ng-template kendoGridCellTemplate let-dataItem>

        <!-- Edit Button -->
        <button kendoButton
                class="m-2 btn btn-success"
                (click)="editPromoCode(dataItem)">
          <span class="k-icon k-i-edit"></span>
        </button>

        <!-- Delete Button -->
        <button class="k-button"
                (click)="removeConfirmation(dataItem)">
          <span class="k-icon k-i-trash"></span>
        </button>

      </ng-template>

    </kendo-grid-command-column>


    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
  <div class="col-sm-12 center">
    <button (click)="togglePromoCodeDialog()" [icon]="'plus'" class="m-3 btn btn-success" kendoButton>
      Add Promo Code
    </button>&nbsp;
   
  </div>
</section>
<section class="dialogSection">
  <kendo-dialog [title]="isEditMode ? 'Edit Promo Code' : 'Add Promo Code'"
                [width]="700"
                [minWidth]="600"
                [maxHeight]="'90vh'"
                *ngIf="promoCodeDialog.opened"
                (close)="togglePromoCodeDialog()">
    <form [formGroup]="promoCodeForm">
      <input type="hidden" formControlName="id" />
      <div class="row">

        <!-- LEFT COLUMN -->
        <div class="col-sm-6">

          <!-- Promo Code -->
          <div class="form-group">
            <label class="lblCls">
              {{promoCodes.promoCodeLbl}}
              <span class="requiredField">*</span>
            </label>

            <div class="d-flex align-items-center">

              <input type="text"
                     kendoTextBox
                     formControlName="code"
                     maxlength="8"
                     class="promoCodeInput"
                     [ngClass]="{'borderRed': isFieldInvalid('code')}" />

              <button kendoButton
                      type="button"
                      class="btn btn-primary ml-2"
                      (click)="generatePromoCode()">
                Auto Generate
              </button>

            </div>

            <div class="promo-code-info mt-1">

              <small [style.color]="(promoCodeForm.get('code')?.value?.length || 0) === 8 ? 'green' : '#666'">
                {{ promoCodeForm.get('code')?.value?.length || 0 }}/8
              </small>

              <span class="promo-info-icon ml-2"
                    title="Maximum 8 characters.">
                ⓘ
              </span>

            </div>

            <div class="text-danger mt-1"
                 *ngIf="promoCodeForm.get('code')?.errors?.invalidPromoCode
            && promoCodeForm.get('code')?.touched">
              Promo code must contain at least 4 letters and 4 numbers.
            </div>
          </div>

          <!-- Description -->
          <div class="form-group">

            <label class="lblCls">
              {{promoCodes.promoCodeDescriptionLbl}}
              <span class="requiredField">*</span>
            </label>

            <input type="text"
                   kendoTextBox
                   formControlName="description"
                   maxlength="35"
                   class="kendoInput"
                   [ngClass]="{'borderRed': isFieldInvalid('description')}" />

            <div class="mt-1">
              <small [style.color]="(promoCodeForm.get('description')?.value?.length || 0) === 35 ? 'green' : '#666'">

                {{ promoCodeForm.get('description')?.value?.length || 0 }}/35

              </small>
            </div>

          </div>

          <!-- Start Date -->
          <div class="form-group">
            <label class="lblCls">{{promoCodes.startDateLbl}}<span class="requiredField">*</span></label>
            <kendo-datepicker formControlName="startDate"
                              class="kendoInput"
                              format="MM/dd/yyyy"
                              [min]="today"
                              [ngClass]="{'borderRed': isFieldInvalid('startDate')}">
            </kendo-datepicker>
          </div>

          <!-- End Date -->
          <div class="form-group">
            <label class="lblCls">{{promoCodes.endDateLbl}}<span class="requiredField">*</span></label>
            <kendo-datepicker formControlName="endDate"
                              class="kendoInput"
                              format="MM/dd/yyyy"
                              [min]="promoCodeForm.get('startDate')?.value || today"
                              [focusedDate]="promoCodeForm.get('startDate')?.value || today"
                              [ngClass]="{'borderRed': isFieldInvalid('endDate')}">
            </kendo-datepicker>
          </div>

          <!-- Product -->
          <div class="form-group">

            <label class="lblCls">
              Product
              <span class="requiredField">*</span>
            </label>

            <div>

              <label>
                <input type="radio"
                       value="EXT"
                       formControlName="productCategory"
                       (change)="onProductCategoryChange('EXT')">
                Product - EXT
              </label>

              <label style="margin-left:15px;">
                <input type="radio"
                       value="BB"
                       formControlName="productCategory"
                       (change)="onProductCategoryChange('BB')">
                Product - B&amp;B
              </label>
              <label style="margin-left:15px;">
                <input type="radio"
                       value="ALL"
                       formControlName="productCategory"
                       (change)="onProductCategoryChange('ALL')">
                All
              </label>
            </div>

          </div>

          <!-- EXT Product MultiSelect -->
          <div class="form-group"
               *ngIf="selectedProductCategory === 'EXT'">

            <kendo-multiselect [data]="extProductList"
                               textField="productName"
                               valueField="productName"
                               [valuePrimitive]="true"
                               formControlName="productType"
                               [autoClose]="false"
                               (valueChange)="onProductChange($event)">
            </kendo-multiselect>

          </div>

          <!-- B&B Product MultiSelect -->
          <div class="form-group"
               *ngIf="selectedProductCategory === 'BB'">

            <kendo-multiselect [data]="bbProductList"
                               textField="productName"
                               valueField="id"
                               [valuePrimitive]="true"
                               formControlName="productType"
                               [autoClose]="false"
                               (valueChange)="onProductChange($event)">
            </kendo-multiselect>

          </div>
          <div class="form-group"
               *ngIf="selectedProductCategory === 'ALL'">

            <kendo-multiselect [data]="allProductList"
                               textField="productName"
                               valueField="productName"
                               [valuePrimitive]="true"
                               formControlName="productType"
                               [autoClose]="false"
                               (valueChange)="onProductChange($event)">
            </kendo-multiselect>

          </div>
          <!-- Source -->
          <div class="form-group">
            <label class="lblCls">
              Source
              <span class="requiredField">*</span>
            </label>
            <label>
              <input type="radio"
                     [value]="1"
                     formControlName="source">
              Any
            </label>

            <label style="margin-left:15px;">
              <input type="radio"
                     [value]="0"
                     formControlName="source">
              PartnerPak
            </label>
          </div>
          <!-- Finish -->
          <div class="form-group">
            <label class="lblCls">
              Finish
              <span class="requiredField">*</span>
            </label>

            <kendo-multiselect [data]="finishList"
                               class="promo-multiselect"
                               textField="name"
                               valueField="value"
                               [valuePrimitive]="true"
                               formControlName="finish"
                               [autoClose]="false"
                               (valueChange)="onFinishChange($event)">
            </kendo-multiselect>

          </div>

          <!-- Free Freight -->
          <div class="form-group"
               [ngClass]="{'borderRed': isFieldInvalid('freeFreight')}">
            <label class="lblCls">Free Freight<span class="requiredField">*</span></label>
            <label>
              <input type="radio" [value]="true" formControlName="freeFreight"> Yes
            </label>
            <label style="margin-left:10px;">
              <input type="radio" [value]="false" formControlName="freeFreight"> No
            </label>
          </div>

          <!-- One Time -->
          <div class="form-group"
               [ngClass]="{'borderRed': isFieldInvalid('oneTime')}">
            <label class="lblCls">One Time<span class="requiredField">*</span></label>
            <label>
              <input type="radio" [value]="true" formControlName="oneTime"> Yes
            </label>
            <label style="margin-left:10px;">
              <input type="radio" [value]="false" formControlName="oneTime"> No
            </label>
          </div>

        </div>

        <!-- RIGHT COLUMN -->
        <div class="col-sm-6">

          <!-- Min Value -->
          <div class="form-group">
            <label class="lblCls">{{promoCodes.minPriceLbl}}</label>
            <kendo-numerictextbox formControlName="minPrice"
                                  class="kendoInput"
                                  [ngClass]="{'borderRed': isFieldInvalid('minPrice')}">
            </kendo-numerictextbox>
          </div>

          <!-- Max Value -->
          <div class="form-group">
            <label class="lblCls">{{promoCodes.maxPriceLbl}}</label>
            <kendo-numerictextbox formControlName="maxPrice"
                                  class="kendoInput">
            </kendo-numerictextbox>
          </div>

          <!-- Discount Type -->
          <div class="form-group"
               [ngClass]="{'borderRed': isFieldInvalid('discountType')}">

            <label class="lblCls">Discount Type<span class="requiredField">*</span></label>

            <label>
              <input type="radio" value="Percentage" formControlName="discountType"> % Discount
            </label>

            <label style="margin-left:10px;">
              <input type="radio" value="Amount" formControlName="discountType"> $ Discount
            </label>
          </div>


          <!-- Discount Value -->
          <div class="form-group" [ngClass]="{'borderRed': isFieldInvalid('discount')}">
            <label class="lblCls">Discount<span class="requiredField">*</span></label>

            <input type="text"
                   kendoTextBox
                   formControlName="discount" (input)="onDiscountInput($event)"
                   class="kendoInput discount-input" />
          </div>

          <!-- Currency -->
          <div class="form-group">
            <label class="lblCls">Currency<span class="requiredField">*</span></label>
            <kendo-multiselect [data]="currencyList"
                               textField="text"
                               valueField="value"
                               [valuePrimitive]="true"
                               formControlName="currency"
                               [autoClose]="false"
                               (valueChange)="onCurrencyChange($event)">
            </kendo-multiselect>
          </div>

          <div class="form-group">

            <label class="lblCls">
              Selection Type
              <span class="requiredField">*</span>
            </label>

            <label>
              <input type="radio"
                     value="Region"
                     formControlName="customerFilterType"
                     [attr.disabled]="disableRegionTerritory ? true : null"
                     (change)="onSelectionTypeChange('Region', true)">
              Region
            </label>

            <label style="margin-left:15px;">
              <input type="radio"
                     value="Territory"
                     formControlName="customerFilterType"
                     [attr.disabled]="disableRegionTerritory ? true : null"
                     (change)="onSelectionTypeChange('Territory', true)">
              Territory
            </label>

            <label style="margin-left:15px;">
              <input type="radio"
                     value="Customer"
                     formControlName="customerFilterType"
                     (change)="onSelectionTypeChange('Customer', true)">
              Customer
            </label>

          </div>
          <div class="form-group">

            <label class="lblCls"><!--
              Value
              <span class="requiredField">*</span>-->
            </label>

            <kendo-multiselect [data]="selectionList"
                               textField="text"
                               valueField="value"
                               [valuePrimitive]="true"
                               formControlName="customerSelection"
                               [autoClose]="false"
                               (valueChange)="onCustomerSelectionChange($event)">
            </kendo-multiselect>
            <div class="mt-2"
                 *ngIf="promoCodeForm.get('oneTime')?.value === true">
              <a class="customer-one-time-link"
                 (click)="openCustomerOneTimeUsage()">
                Customer One-Time Usage
              </a>
            </div>
          </div>

          <!-- Active -->
          <div class="form-group">
            <label class="lblCls">IsActive</label>
            <kendo-switch formControlName="isActive"
                          [ngClass]="{'borderRed': isFieldInvalid('isActive')}">
            </kendo-switch>
          </div>

        </div>

      </div>

      <div class="dialog-btn-section">
        <div class="row">
          <div class="col-sm-12 float-left">
            <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 btn-align-center">
            <div class="btn-group" role="group">
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn k-button dialogBtnSize"
                      (click)="togglePromoCodeDialog()">
                Close
              </button> &nbsp;&nbsp;
              <button kendoButton [disabled]="saveInProcess" class=" m-3 btn btn-success dialogBtnSize"
                      (click)="savePromoCode()">
                Save<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </kendo-dialog>
  <kendo-dialog title="Customer One-Time Usage"
                [width]="700"
                *ngIf="customerOneTimeUsageDialog.opened"
                (close)="closeCustomerOneTimeUsage()">

    <kendo-grid [data]="customerOneTimeUsageList"
                [height]="400"
                [filterable]="true"
                [sortable]="true">

      <kendo-grid-column field="customer"
                         title="Customer">
      </kendo-grid-column>

      <kendo-grid-column field="promoCodeOneTimeUse"
                         title="Active"
                         [width]="120">

        <ng-template kendoGridCellTemplate let-dataItem>

          <kendo-switch [(ngModel)]="dataItem.promoCodeOneTimeUse">
          </kendo-switch>

        </ng-template>

      </kendo-grid-column>

    </kendo-grid>

    <kendo-dialog-actions>

      <button kendoButton
              (click)="closeCustomerOneTimeUsage()">
        Close
      </button>

    </kendo-dialog-actions>

  </kendo-dialog>
</section>
<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
    <b> : {{ gridItemToRemove.code }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
